export default "__VITE_ASSET__0FtPjniP__"